"use client";
var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/components/cosmic/background-stars.tsx
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { generateRandomStars } from "./utils/background-utils.js";
import { jsx } from "react/jsx-runtime";
function TwinklingStars({ count, intensity }) {
  const [stars, setStars] = useState([]);
  useEffect(() => {
    const validCount = Math.max(0, Math.min(1e3, Math.floor(count || 0)));
    if (validCount > 0) {
      setStars(generateRandomStars(validCount));
    } else {
      setStars([]);
    }
  }, [count]);
  const validIntensity = Math.max(0.1, Math.min(2, intensity || 1));
  return /* @__PURE__ */ jsx("div", { className: "absolute inset-0 overflow-hidd\
en pointer-events-none", children: stars.map((star) => /* @__PURE__ */ jsx(
    motion.div,
    {
      className: "absolute bg-slate-12 dark:bg-slate-1 rounded-full",
      style: {
        left: `${star.x}%`,
        top: `${star.y}%`,
        width: `${star.size}px`,
        height: `${star.size}px`
      },
      animate: {
        opacity: [0.2, 0.8 * validIntensity, 0.2],
        scale: [0.8, 1.2 * validIntensity, 0.8]
      },
      transition: {
        duration: 2 + star.delay,
        repeat: Number.POSITIVE_INFINITY,
        delay: star.delay,
        ease: "easeInOut"
      }
    },
    star.id
  )) });
}
__name(TwinklingStars, "TwinklingStars");
export {
  TwinklingStars
};
